// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAvailabilityStyles } from "@awc/Overrides/Components/ProductAvailability";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import Truck from "@insite/mobius/Icons/Truck";
import { css } from "styled-components";

productAvailabilityStyles.inventoryMessage = {
    css: css`
        background-color: transparent;
        display: flex;
        align-items: center;
        padding: 0;
        gap: 7px;
        ${wrapInContainerStyles}
    `,
};

productAvailabilityStyles.messageText = {
    size: fontConfig.fontSize.xSmall,
    lineHeight: fontConfig.lineHeight.xSmall,
};

productAvailabilityStyles.availabilityByWarehouseLinkGridItem = {
    css: css`
        align-items: center;
        display: flex;
    `,
};

productAvailabilityStyles.availabilityByWarehouseLink = {
    icon: {
        iconProps: {
            src: Truck,
        },
    },
};
